export class MetricTimeseriesPoint {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ts",
            "baseName": "ts",
            "type": "number",
            "format": ""
        },
        {
            "name": "value",
            "baseName": "value",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MetricTimeseriesPoint.attributeTypeMap;
    }
    constructor() {
    }
}
